import React, { FC } from 'react';

import Modal from '~components/atoms/Modal';

import CreateStockOutForm from '../CreateStockOutForm';

type CreateStockOutModalProps = {
    isOpen: boolean;
    onClose: () => void;
}

const CreateStockOutModal: FC<CreateStockOutModalProps> = ({
    isOpen,
    onClose,
}) => {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title='Create Stock Out'
        >
            <CreateStockOutForm />
        </Modal>
    );
};

export default CreateStockOutModal;
